module.exports = __webpack_public_path__ + "static/media/Profile_Picture.53047a70.jpg";